import DeleteButton from '@components/DeleteButton'

const ListItem = ({ tag, make, model, onDelete, pending }) => (
    <li className="car text-large">
        <span className="make-and-model">{`${make} ${model}`}</span>
        <span className="tag">{tag}</span>
        <DeleteButton onClick={onDelete} pending={pending} />
    </li>
)

export default ListItem
